import React, { useState, useRef, useEffect } from 'react';
import { Checkbox, Button, SparkIcon } from '@spark';
import './StatusFilter.css';

const StatusFilter = ({
    selectedStatuses,
    onStatusChange,
    onReset,
    onApply
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [tempSelectedStatuses, setTempSelectedStatuses] = useState(selectedStatuses);
    const filterRef = useRef(null);

    const statusOptions = [
        { key: 'running', label: 'Training' },
        { key: 'completed', label: 'Complete' },
        { key: 'failed', label: 'Failed' },
        { key: 'waiting', label: 'Waiting' }
    ];

    useEffect(() => {
        setTempSelectedStatuses(selectedStatuses);
    }, [selectedStatuses]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleStatusToggle = (statusKey) => {
        setTempSelectedStatuses(prev =>
            prev.includes(statusKey)
                ? prev.filter(s => s !== statusKey)
                : [...prev, statusKey]
        );
    };

    const handleReset = () => {
        setTempSelectedStatuses([]);
        onReset();
        setIsOpen(false);
    };

    const handleApply = () => {
        onStatusChange(tempSelectedStatuses);
        onApply(tempSelectedStatuses);
        setIsOpen(false);
    };

    const getSelectedCount = () => {
        return selectedStatuses.length;
    };

    return (
        <div className="status-filter-container" ref={filterRef}>
            <div
                className="status-filter-trigger"
                onClick={() => setIsOpen(!isOpen)}
            >
                <SparkIcon slug="filter" size="small" className="status-filter-icon" />
                <span className="filter-placeholder">
                    {getSelectedCount() > 0 ? `Filter (${getSelectedCount()})` : 'Filter by status'}
                </span>
            </div>

            {isOpen && (
                <div className="status-filter-popup">
                    <div className="popup-header">
                        <span className="popup-title">Filter by status</span>
                    </div>

                    <div className="popup-content">
                        {statusOptions.map(option => (
                            <div key={option.key} className="status-option">
                                <Checkbox
                                    label={option.label}
                                    status={tempSelectedStatuses.includes(option.key) ? 'active' : 'inactive'}
                                    onChange={() => handleStatusToggle(option.key)}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="popup-actions">
                        <Button
                            variant="ghost"
                            size="small"
                            onClick={handleReset}
                        >
                            Reset
                        </Button>
                        <Button
                            variant="primary"
                            size="small"
                            onClick={handleApply}
                        >
                            OK
                        </Button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StatusFilter;
